var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "40px",
    viewBox: "0 0 164 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AFA04E00-AAB7-4D41-B752-CDB9A46C25CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.100753282 33.120749 0.100753282 33.120749 38.6931298 0 38.6931298"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0319650276 0.192558779 33.155159 0.192558779 33.155159 38.9614424 0.0319650276 38.9614424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 39.4074412 163.867099 39.4074412 163.867099 0.302290076 0 0.302290076"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "U4-Desktop-Drop-Down",
    transform: "translate(-52.000000, -45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Navigation",
    transform: "translate(52.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.714311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5538814,0.100753282 L25.5538814,22.7356296 C25.5538814,28.3733395 22.1919694,31.7390373 16.5614159,31.7390373 C10.8940376,31.7390373 7.51129855,28.3733395 7.51129855,22.7356296 L7.51129855,0.100753282 L-3.01841621e-05,0.100753282 L-3.01841621e-05,21.878335 C-3.01841621e-05,31.9355258 6.65587939,38.6932205 16.5614159,38.6932205 C26.4660468,38.6932205 33.120749,31.9355258 33.120749,21.878335 L33.120749,0.100753282 L25.5538814,0.100753282 Z",
    id: "Fill-1",
    fill: "#7C878F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(42.559669, 0.109731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5931092,0.192437863 C6.68757276,0.192437863 0.0319650276,6.94922565 0.0319650276,17.004905 L0.0319650276,38.9614424 L7.60154919,38.9614424 L7.60154919,16.1497264 C7.60154919,10.5108073 10.9631593,7.14450504 16.5931092,7.14450504 C22.259582,7.14450504 25.6429247,10.5108073 25.6429247,16.1497264 L25.6429247,38.9614424 L33.155159,38.9614424 L33.155159,17.004905 C33.155159,6.94922565 26.4992494,0.192437863 16.5931092,0.192437863",
    id: "Fill-4",
    fill: "#7C878F",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#7C878F",
    mask: "url(#mask-6)",
    points: "86.9644948 39.0712947 94.4761254 39.0712947 94.4761254 0.814974046 86.9644948 0.814974046"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#7C878F",
    mask: "url(#mask-6)",
    points: "104.509492 0.815064733 104.509492 7.9379258 115.759431 7.9379258 115.759431 39.0710831 123.269854 39.0710831 123.269854 7.9379258 134.521 7.9379258 134.521 0.815064733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.867069,0.815064733 L155.739078,0.815064733 L137.479773,26.427196 C136.948532,27.1898739 136.745392,28.1136724 136.908085,29.0290067 C137.070777,29.9452479 137.57938,30.7417823 138.340927,31.2732082 C138.925594,31.6837182 139.613793,31.9004602 140.330365,31.9004602 L140.330667,31.9004602 L154.270317,31.8941121 L154.270317,39.0710831 L161.222635,39.0710831 L161.244367,25.908164 L146.318299,25.908164 L163.867069,0.815064733 Z",
    id: "Fill-10",
    fill: "#85BC3B",
    mask: "url(#mask-6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit4);
export default __webpack_public_path__ + "static/media/unit4.95b81c5261e82bcaa36f761f85785263.svg";
export { ForwardRef as ReactComponent };